import { render } from "./trygameRecord.vue?vue&type=template&id=5cf27f58&scoped=true"
import script from "./trygameRecord.vue?vue&type=script&lang=js"
export * from "./trygameRecord.vue?vue&type=script&lang=js"

import "../../styles/removeVantcell.css?vue&type=style&index=0&id=5cf27f58&scoped=true&lang=css"
import "./trygameRecord.vue?vue&type=style&index=1&id=5cf27f58&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf27f58"]])

export default __exports__